module.exports = __webpack_public_path__ + "static/android-05d97c9210d491b39211455e7259b41f.svg";